import { render, staticRenderFns } from "./GroupTable.html?vue&type=template&id=6476306c&"
import script from "./GroupTable.js?vue&type=script&lang=js&"
export * from "./GroupTable.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports